import type { Player, Tournament } from '@/lib/types/auction';
import { PlayerCard } from './PlayerCard';
import { EmptyState } from '@/components/common/EmptyState';
import { User } from 'lucide-react';

interface PlayerGridProps {
  players: Player[];
  tournament?: Tournament;
  onSelectPlayer?: (player: Player) => void;
  selectedPlayers?: Set<string>;
}

export function PlayerGrid({
  players,
  tournament,
  onSelectPlayer,
  selectedPlayers = new Set(),
}: PlayerGridProps) {
  if (players.length === 0) {
    return (
      <EmptyState
        title="No Players Available"
        message="There are no players registered at the moment."
        icon={<User className="h-12 w-12" />}
      />
    );
  }

  return (
    <div
      className="grid auto-rows-fr gap-4"
      style={{
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 280px), 1fr))',
      }}
    >
      {players.map((player) => (
        <PlayerCard
          key={player.id}
          player={player}
          tournament={tournament}
          selected={selectedPlayers.has(player.id)}
          onSelect={() => onSelectPlayer?.(player)}
        />
      ))}
    </div>
  );
}
